import { render, staticRenderFns } from "./DualList.vue?vue&type=template&id=af3d8d8a&"
import script from "./DualList.vue?vue&type=script&lang=js&"
export * from "./DualList.vue?vue&type=script&lang=js&"
import style0 from "./DualList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports